import { Route } from '@angular/router';
import { DeviceDetailsAttributesComponent } from 'src/app/pages/network/device-details/device-details-attributes/device-details-attributes.component';
import { DeviceDetailsLogComponent } from 'src/app/pages/network/device-details/device-details-log/device-details-log.component';
import { DeviceDetailsOverviewComponent } from 'src/app/pages/network/device-details/device-details-overview/device-details-overview.component';
import { DeviceDetailsPlaylistsComponent } from 'src/app/pages/network/device-details/device-details-playlists/device-details-playlists.component';
import { DeviceDetailsPlayoutsComponent } from 'src/app/pages/network/device-details/device-details-playouts/device-details-playouts.component';
import { DeviceDetailsComponent } from 'src/app/pages/network/device-details/device-details.component';
import { DevicesComponent } from 'src/app/pages/network/devices/devices.component';
import { DeviceDetailsGeoStatsComponent } from 'src/app/pages/network/device-details/device-details-geo-stats/device-details-geo-stats.component';
import { DeviceDetailsPositionsComponent } from 'src/app/pages/network/device-details/device-details-positions/device-details-positions.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { DeviceAttachmentsComponent } from '../../../../../pages/network/device-details/device-attachments/device-attachments.component';
import { DeviceDetailsScreensComponent } from '../../../../../pages/network/device-details/device-details-screens/device-details-screens.component';
import { DeviceDetailsContentShareComponent } from '../../../../../pages/network/device-details/device-details-content-share/device-details-content-share.component';
import { DeviceDetailsSetlistsComponent } from '../../../../../pages/network/device-details/device-details-setlists/device-details-setlists.component';
import { DeviceDetailsPlaybackScheduleComponent } from '../../../../../pages/network/device-details/device-details-playback-schedule/device-details-playback-schedule.component';
import { DeviceDetailsActivityComponent } from '../../../../../pages/network/device-details/device-details-activity/device-details-activity.component';
import { DeviceDetailsNetworkAccessComponent } from '../../../../../pages/network/device-details/device-details-network-access/device-details-network-access.component';
import { DeviceDetailsNetworkBookingsComponent } from '../../../../../pages/network/device-details/device-details-network-bookings/device-details-network-bookings.component';

export const devices: Route = {
  path: 'devices',
  title: 'nav.network.devices',
  data: {
    breadcrumb: 'nav.network.devices',
    icon: SbIcons.playerOnline,
    id: RoutingID.devices,
  },
  children: [
    {
      path: '',
      component: DevicesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'device-details/:deviceID',
      title: 'nav.network.devices.details',
      data: {
        breadcrumb: 'nav.network.devices.details',
        icon: SbIcons.details,
        id: RoutingID.deviceDetails,
      },
      children: [
        {
          path: '',
          component: DeviceDetailsComponent,
          data: {
            breadcrumb: '',
          },
          children: [
            {
              path: 'device-details-overview',
              component: DeviceDetailsOverviewComponent,
              title: 'nav.network.devices.details.overview',
              data: {
                breadcrumb: 'nav.network.devices.details.overview',
                icon: SbIcons.eye,
                id: RoutingID.deviceDetailsOverview,
              },
            },
            {
              path: 'device-details-attributes',
              component: DeviceDetailsAttributesComponent,
              title: 'nav.network.devices.details.attributes',
              data: {
                breadcrumb: 'nav.network.devices.details.attributes',
                icon: SbIcons.attributes,
                id: RoutingID.deviceDetailsAttributes,
              },
            },
            {
              path: 'device-details-activity',
              component: DeviceDetailsActivityComponent,
              data: {
                breadcrumb: 'nav.network.devices.details.activity',
                icon: SbIcons.online,
                id: RoutingID.deviceDetailsActivity,
              },
            },
            {
              path: 'device-details-playouts',
              component: DeviceDetailsPlayoutsComponent,
              title: 'nav.network.devices.details.playouts',
              data: {
                breadcrumb: 'nav.network.devices.details.playouts',
                icon: SbIcons.pieChartStake,
                id: RoutingID.deviceDetailsPlayouts,
              },
            },
            {
              path: 'device-details-positions',
              component: DeviceDetailsPositionsComponent,
              title: 'nav.network.devices.details.positions',
              data: {
                breadcrumb: 'nav.network.devices.details.positions',
                icon: SbIcons.locationStreet,
                id: RoutingID.deviceDetailsPositions,
              },
            },
            {
              path: 'device-details-log',
              component: DeviceDetailsLogComponent,
              title: 'nav.network.devices.details.log',
              data: {
                breadcrumb: 'nav.network.devices.details.log',
                icon: SbIcons.list,
                id: RoutingID.deviceDetailsLog,
              },
            },
            {
              path: 'device-details-geoStats',
              component: DeviceDetailsGeoStatsComponent,
              title: 'nav.network.devices.details.geoStats',
              data: {
                breadcrumb: 'nav.network.devices.details.geoStats',
                icon: SbIcons.location,
                id: RoutingID.deviceDetailsGeoStats,
              },
            },
            {
              path: 'device-details-playlists',
              component: DeviceDetailsPlaylistsComponent,
              title: 'nav.network.devices.details.playlists',
              data: {
                breadcrumb: 'nav.network.devices.details.playlists',
                icon: SbIcons.schedules,
                id: RoutingID.deviceDetailsPlaylist,
              },
            },
            {
              path: 'device-details-setlists',
              component: DeviceDetailsSetlistsComponent,
              data: {
                breadcrumb: 'nav.network.devices.details.setlist',
                icon: SbIcons.bookingList,
                id: RoutingID.deviceDetailsSetlist,
              },
            },
            {
              path: 'device-details-network-access',
              component: DeviceDetailsNetworkAccessComponent,
              data: {
                breadcrumb: 'nav.network.devices.details.networkAccess',
                icon: SbIcons.networkShare,
                id: RoutingID.deviceDetailsNetworkAccess,
              },
            },
            {
              path: 'device-details-network-bookings',
              component: DeviceDetailsNetworkBookingsComponent,
              data: {
                breadcrumb: 'nav.network.bookings',
                icon: SbIcons.bookings,
                id: RoutingID.deviceDetailsNetworkBookings,
              },
            },
            {
              path: 'device-details-content-share',
              component: DeviceDetailsContentShareComponent,
              data: {
                breadcrumb: 'nav.campaigns.contentShare',
                icon: SbIcons.management,
                id: RoutingID.deviceDetailsContentShare,
              },
            },
            {
              path: 'device-details-playback-schedule',
              component: DeviceDetailsPlaybackScheduleComponent,
              data: {
                breadcrumb: 'nav.network.devices.details.playbackSchedule',
                icon: SbIcons.schedules,
                id: RoutingID.deviceDetailsPlaybackSchedule,
              },
            },
            {
              path: 'device-details-screens',
              component: DeviceDetailsScreensComponent,
              title: 'lang.globals.screens',
              data: {
                breadcrumb: 'lang.globals.screens',
                icon: SbIcons.screen,
                id: RoutingID.deviceDetailsScreens,
              },
            },
            {
              path: 'device-details-attachments',
              component: DeviceAttachmentsComponent,
              title: 'nav.network.devices.details.playlists',
              data: {
                breadcrumb: 'nav.network.devices.details.attachments',
                icon: SbIcons.attachments,
                id: RoutingID.deviceDetailsAttachments,
              },
            },
            {
              path: '',
              redirectTo: RoutingID.deviceDetailsOverview,
              pathMatch: 'full',
            },
          ],
        },
      ],
    },
  ],
};
